import { render, staticRenderFns } from "./boundary.vue?vue&type=template&id=470f9074&scoped=true"
import script from "./boundary.vue?vue&type=script&lang=js"
export * from "./boundary.vue?vue&type=script&lang=js"
import style0 from "./boundary.vue?vue&type=style&index=0&id=470f9074&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f9074",
  null
  
)

export default component.exports